<div class="d-flex flex-row h-100">
  <div class="pr-2 d-flex flex-column justify-content-between h-100">
    <div>
      <div class="card p-2">
        Paths:
        <div *ngIf="bLoading" class="text-secondary font-italic">
          <i class="fa fa-spinner fa-spin"></i>&nbsp;Loading point data...
        </div>
        <div class="overflow-auto" style="max-height: calc(100vh - 380px)">
          <div *ngFor="let path of paths">
            <input
              type="checkbox"
              [(ngModel)]="pathIdsSelected[path.id]"
              (change)="onPathSelected(path.id)"
            />
            {{ path.buildingId }} #{{ path.pathNumber }}
            <span *ngIf="path.floor" class="small font-italic text-secondary"
              >(floor {{ path.floor }})</span
            >
          </div>
        </div>
      </div>
      <div class="card p-2 my-2">
        <label class="mt-2 mb-0">
          <input
            type="checkbox"
            [(ngModel)]="bAnchorToGround"
            (change)="initCesiumKml(true)"
          />
          Flatten (2D - ground level)
        </label>
        <ng-container *ngIf="!bAnchorToGround">
          <!--
            <label class="mt-2 mb-0">
                <input type="checkbox" [(ngModel)]="bIncludeTerrain" (change)="initCesiumKml(true)"/>
                Terrain
            </label>
            -->
          <label class="mt-2 mb-0">
            <input
              *ngIf="!bLoadingBuildingTiles"
              type="checkbox"
              [(ngModel)]="bIncludeBuildings"
              (change)="initBuildingsTileset()"
            />
            <i
              *ngIf="bLoadingBuildingTiles"
              class="fa fa-spinner fa-spin mr-2"
            ></i>
            Building Tiles
          </label>
        </ng-container>
        <label class="mt-2 mb-0" *ngIf="hasOverlays">
          <input
            type="checkbox"
            [(ngModel)]="bShowOverlays"
            (change)="onToggleOverlays()"
          />
          Overlays
        </label>
      </div>
      <div class="pt-4" style="min-width: 20em">
        <button
          (click)="onExportAsKmz()"
          class="mx-2 btn btn-secondary btn-sm"
          [disabled]="bProcessing"
        >
          Export (KML)
        </button>
        <button
          class="btn btn-secondary btn-sm"
          (click)="onUpdateMap()"
          [disabled]="bProcessing"
        >
          Update Map
        </button>
      </div>
    </div>
    <div class="d-flex justify-content-end align-items-start">
      <button (click)="close.next()" class="ml-2 btn btn-primary btn-sm">
        Close
      </button>
    </div>
  </div>
  <div style="height: 100%; width: 100%" #cesiumMapDiv></div>
</div>
